import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';
import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
  selectContainer: (bool = false) => css`
    width: 100%;
    margin: 1.6rem 0;
    display: ${bool ? 'none' : 'block'};
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.accentGrayUltralight};
    }
  `,
};

const MailingState = props => {
  const { form, info, key, onChange } = props;
  const { options = [], optionId, optionDesc, isMailing } = info;

  const dispatch = useDispatch();

  const { register } = useSelector(state => state);

  const { isOtherMailingStateVisible, isMailingAddressDisabled } = register;
  const isFieldVisible = Boolean(isMailing) && isMailingAddressDisabled;

  const stateChange = e => {
    if (e === 'Other') {
      dispatch(handleFormChange({ name: 'isOtherMailingStateVisible', value: true }));
    } else {
      dispatch(handleFormChange({ name: 'isOtherMailingStateVisible', value: false }));
    }
  };

  useEffect(() => {
    if (register.PoBoxStateCode === 'Other') {
      dispatch(handleFormChange({ name: 'isOtherMailingStateVisible', value: true }));
    }
  }, []);

  return (
    <>
      <div key={optionId} css={styles.selectContainer(isFieldVisible)}>
        <Form.Item label="State">
          {form.getFieldDecorator('PoBoxStateCode', {
            initialValue: register['PoBoxStateCode'],
            rules: [{ required: !isMailingAddressDisabled, message: 'Select State.' }],
          })(
            <Select
              disabled={isMailing && isMailingAddressDisabled}
              showSearch
              allowClear
              onChange={e => {
                stateChange(e);
                onChange('PoBoxStateCode', e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
              optionFilterProp="children"
            >
              {options.map(option => (
                <Option key={`PoBoxStateCode-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherMailingStateVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="State/Region/Province">
            {form.getFieldDecorator('PoBoxOther', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter State/Region/Province.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('PoBoxOther', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

export default MailingState;
